var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhtBlueLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106,
    height: 70,
    viewBox: "0 0 106 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "100%",
    x2: "50%",
    y1: "16.613%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E3EAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "20.743%",
    y1: "19.367%",
    y2: "86.962%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDF3FE"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "c",
    width: 14,
    height: 11,
    y: 6,
    rx: 5.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#158CCC",
    d: "M28.928 29.405v3.597L5.765 34v-4.595H0V16.541C0 7.405 7.61 0 17 0s17 7.405 17 16.54v12.865h-5.072zm0 0V18.252c0-6.224-5.185-11.268-11.581-11.268-6.397 0-11.582 5.044-11.582 11.268v11.153h23.163z",
    transform: "translate(34)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#23356C",
    d: "M45.62 68.079H8.38c-4.114 0-7.449-3.3-7.449-7.368V36.763c0-4.07 3.335-7.368 7.448-7.368h37.242c4.113 0 7.448 3.299 7.448 7.368v23.948c0 4.069-3.335 7.368-7.448 7.368z",
    transform: "translate(24)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 44 56)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 10,
    x: 0.5,
    y: 6.5,
    stroke: "#158CCC",
    rx: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7,
    cy: 4.5,
    fill: "#FFF",
    stroke: "#158CCC",
    rx: 3,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M5 7h4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3 8h9v5H3z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 52.5,
    r: 4.5,
    stroke: "#A8CADD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 22,
    r: 3,
    fill: "#158CCC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 52,
    r: 3,
    fill: "#CBECFD"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7EB8D8",
    strokeLinecap: "square",
    d: "M94.5 10.5v9M97.5 13.902h-6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhtBlueLock);
export default __webpack_public_path__ + "static/media/whtBlue-lock.54496eb933fed2a68b85ed862cfabfc1.svg";
export { ForwardRef as ReactComponent };